import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Content, Main } from "../../../components/Layout";
import api from "../../../services/api";
import { Row, Col, Form } from "react-bootstrap";
import { InputDocument, Phone } from "../../../components/Input";
import Slct from "../../../components/Slct";
import styleTab from "../../../components/Tab/Tab.module.css";
import styleButton from "../../../components/Button/Button.module.css";
import { toast } from "react-toastify";
import Wizard from "../../../components/Wizard";
import PasswordStrength from "../../../components/PasswordStrength";
import { ModalChangePass } from "../../../components/Modal";
import Loading from "../../../components/Loading";
import Permissions from "../../../components/Permissions";
import useWrapper from "../../../hooks/useWrapper";
import useIsSystemAdmin, { SYSTEM_ADMIN_SECTOR } from "../../../hooks/useIsSystemAdmin";

export default function AdminUserEdit() {
  const { setbreadcrumb, config } = useWrapper();
  const isSystemAdmin = useIsSystemAdmin();
  const { userId } = useParams();
  const isUser = !isNaN(parseInt(userId));

  const navigate = useNavigate();

  const [user, setuser] = useState({
    resource: [],
  });
  const [categories, setcategories] = useState();
  const [categoriesAtd, setcategoriesAtd] = useState();
  const [templates, settemplates] = useState();
  useEffect(() => {
    api.get("categories", config).then(response => {
      let _categories = [];
      let _categoriesAtd = [];
      response.data.data.forEach(e => {
        let _data = {
          id: e.id,
          name: e.name,
          resource: e.resource.map(e2 => ({ value: e2.id, label: e2.name })),
        };
        !e.only_attendance ? _categories.push(_data) : _categoriesAtd.push(_data);
      });
      setcategories(_categories);
      setcategoriesAtd(_categoriesAtd);
    });

    api.get(`/template-permission`, config).then(response => {
      const _templates = response.data.map(__template => ({
        label: __template.name,
        value: JSON.parse(__template.permissions),
      }));
      settemplates(_templates);
    });
    // config is recreated on every WrapperContext render; this fetch should only run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [loadingPage, setLoadingPage] = useState(true);
  useEffect(() => {
    if (categories && categoriesAtd) {
      if (isUser) {
        api
          .get(`users/${userId}`, config)
          .then(response => {
            if (response.data.sector === SYSTEM_ADMIN_SECTOR && !isSystemAdmin) {
              toast.error("Você não tem permissão para editar um Administrador do Sistema!");
              navigate(`/admin/users`);
              return true;
            }
            const _permissions = JSON.parse(response.data.permissions);
            setuser({
              ...response.data,
              resource: response.data.resource.map(e => ({
                value: e.id,
                label: e.name,
              })),
              access: [
                ...(response.data.calendar ? [{ value: "calendar", label: "Calendário" }] : []),
                ...(response.data.commercial ? [{ value: "commercial", label: "Comercial" }] : []),
                ...(response.data.attendance ? [{ value: "attendance", label: "Atendimento" }] : []),
                ...(response.data.class ? [{ value: "class", label: "Turma" }] : []),
                ...(response.data.institution ? [{ value: "institution", label: "Instituições" }] : []),
                ...(response.data.supplier ? [{ value: "supplier", label: "Fornecedores" }] : []),
                ...(response.data.trainee ? [{ value: "trainee", label: "Formandos" }] : []),
                ...(response.data.financial ? [{ value: "financial", label: "Financeiro" }] : []),
              ],
              permissions: {
                trainee: {
                  create: _permissions?.trainee?.create || false,
                  reading: _permissions?.trainee?.reading || false,
                  update: _permissions?.trainee?.update || false,
                  financialReading: _permissions?.trainee?.financialReading || false,
                  updatePassword: _permissions?.trainee?.updatePassword || false,
                  distrato: _permissions?.trainee?.distrato || false,
                },
                calendar: {
                  createForClass: _permissions?.calendar?.createForClass || false,
                  editForClass: _permissions?.calendar?.editForClass || false,
                  create: _permissions?.calendar?.create || false,
                  update: _permissions?.calendar?.update || false,
                  recalc: _permissions?.calendar?.recalc || false,
                },
                commercial: {
                  create: _permissions?.commercial?.create || false,
                  reading: _permissions?.commercial?.reading || false,
                  update: _permissions?.commercial?.update || false,
                  readingFunnel: _permissions?.commercial?.readingFunnel || false,
                  createModel: _permissions?.commercial?.createModel || false,
                  updateModel: _permissions?.commercial?.updateModel || false,
                  createLegacy: _permissions?.commercial?.createLegacy || false,
                  fileReading: _permissions?.commercial?.fileReading || false,
                  fileCreate: _permissions?.commercial?.fileCreate || false,
                  fileDelete: _permissions?.commercial?.fileDelete || false,
                },
                attendance: {
                  create: _permissions?.attendance?.create || false,
                  reading: _permissions?.attendance?.reading || false,
                  sendMessages: _permissions?.attendance?.sendMessages || false,
                  updateInfos: _permissions?.attendance?.updateInfos || false,
                  finishAttendance: _permissions?.attendance?.finishAttendance || false,
                  fileReading: _permissions?.attendance?.fileReading || false,
                  fileCreate: _permissions?.attendance?.fileCreate || false,
                },
                financialGroup: {
                  reading: _permissions?.financialGroup?.reading || false,
                  create: _permissions?.financialGroup?.create || false,
                  update: _permissions?.financialGroup?.update || false,
                  paymentDown: _permissions?.financialGroup?.paymentDown || false,
                },
                financialCompany: {
                  reading: _permissions?.financialCompany?.reading || false,
                  create: _permissions?.financialCompany?.create || false,
                  update: _permissions?.financialCompany?.update || false,
                  paymentDown: _permissions?.financialCompany?.paymentDown || false,
                },
                suppliers: {
                  create: _permissions?.suppliers?.create || false,
                  reading: _permissions?.suppliers?.reading || false,
                  update: _permissions?.suppliers?.update || false,
                },
                institutions: {
                  create: _permissions?.institutions?.create || false,
                  reading: _permissions?.institutions?.reading || false,
                  update: _permissions?.institutions?.update || false,
                },
                reports: {
                  reading: _permissions?.reports?.reading || false,
                },
              },
            });
          })
          .then(blocked => {
            if (!blocked) {
              setLoadingPage(false);
            }
          });
      } else {
        setuser(prevUser => ({
          ...prevUser,
          permissions: {
            trainee: {
              create: false,
              reading: false,
              update: false,
              financialReading: false,
              updatePassword: false,
              distrato: false,
            },
            calendar: {
              createForClass: false,
              editForClass: false,
              create: false,
              update: false,
              recalc: false,
            },
            commercial: {
              create: false,
              reading: false,
              update: false,
              readingFunnel: false,
              createModel: false,
              updateModel: false,
              createLegacy: false,
              fileReading: false,
              fileCreate: false,
              fileDelete: false,
            },
            attendance: {
              create: false,
              reading: false,
              sendMessages: false,
              updateInfos: false,
              finishAttendance: false,
              fileReading: false,
              fileCreate: false,
            },
            financialGroup: {
              reading: false,
              create: false,
              update: false,
              paymentDown: false,
            },
            financialCompany: {
              reading: false,
              create: false,
              update: false,
              paymentDown: false,
            },
            suppliers: {
              create: false,
              reading: false,
              update: false,
            },
            institutions: {
              create: false,
              reading: false,
              update: false,
            },
            reports: {
              reading: false,
            },
          },
        }));
        setLoadingPage(false);
      }
    }
    // config is recreated on every WrapperContext render (it changes whenever setbreadcrumb fires below);
    // this effect must only run when the fetched category lists or the route/user-type change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories, categoriesAtd, isUser, userId]);

  useEffect(() => {
    if (user.access) {
      user.access.some(e => e.value === "calendar") ? (user.calendar = 1) : (user.calendar = 0);
      user.access.some(e => e.value === "commercial") ? (user.commercial = 1) : (user.commercial = 0);
      user.access.some(e => e.value === "attendance") ? (user.attendance = 1) : (user.attendance = 0);
      user.access.some(e => e.value === "class") ? (user.class = 1) : (user.class = 0);
      user.access.some(e => e.value === "institution") ? (user.institution = 1) : (user.institution = 0);
      user.access.some(e => e.value === "supplier") ? (user.supplier = 1) : (user.supplier = 0);
      user.access.some(e => e.value === "trainee") ? (user.trainee = 1) : (user.trainee = 0);
      user.access.some(e => e.value === "financial") ? (user.financial = 1) : (user.financial = 0);
    }
  }, [user]);

  const saveUser = async () => {
    const _data = {
      username: user.username,
      email: user.email,
      cpf: user.cpf,
      password: user.password,
      cell: user.cell,
      is_whatsapp: user.is_whatsapp,
      sector: user.sector,
      is_admin: user.is_admin,
      calendar: user.calendar,
      commercial: user.commercial,
      attendance: user.attendance,
      class: user.class,
      token: null,
      institution: user.institution,
      supplier: user.supplier,
      trainee: user.trainee,
      financial: user.financial,
      sendEmail: user.sendEmail,
      resources: user.resource.map(e => e.value),
      attendanceResource: [],
      permissions: user.permissions,
    };

    try {
      if (isUser) {
        await api.put(`users/${userId}`, _data, config);
        toast.success("Usuário salvo com sucesso!");
      } else {
        await api.post(`users/`, _data, config);
        toast.success("Usuário criado com sucesso!");
      }
      navigate(`/admin/users`);
    } catch (__err) {
      toast.error("Erro ao tentar cadastrar novo usuário!");
      console.log("__err", __err);
    }
  };

  const [wizard, setwizard] = useState(1);
  const advanceStep = e => {
    let _error = [];
    document.querySelectorAll(".input-empty").forEach(e => {
      e.classList.remove("input-empty");
    });

    setTimeout(() => {
      if (e > wizard || e === "save") {
        if (!user.username) {
          _error.push({ el: "us3r.us3rnam3", wiz: 1 });
        }
        if (!user.email) {
          _error.push({ el: "us3r.3m4il", wiz: 1 });
        }
        if (!user.cell) {
          _error.push({ el: "user.cell", wiz: 1 });
        }
        if (!user.cpf) {
          _error.push({ el: "user.cpf", wiz: 1 });
        }
        if (!user.sector) {
          _error.push({ el: "user.sector", wiz: 1, parent: true });
        }
        if (!isUser) {
          if (!user.password) {
            _error.push({ el: "us3r.p4ssw0rd", wiz: 1 });
          }
          if (user.password !== user.password_confirm) {
            _error.push({ el: "checkPassword", customText: "A confirmação de Senha está errada!", wiz: 1 });
          }
        }
      }
      if (_error.length > 0) {
        let _custom_text_el = _error.find(el => el.customText);
        if (_custom_text_el) {
          toast.error(_custom_text_el.customText);
        } else {
          toast.error("Preencha todos os dados obrigatórios!");
        }
        _error.forEach(er => {
          if (er.wiz === _error[0].wiz && er.el) {
            if (er.parent) {
              document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
                el.parentElement.classList.add("input-empty");
              });
            } else if (er.multi) {
              document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
                el.parentElement.parentElement.classList.add("input-empty");
                el.parentElement.parentElement.classList.add("empty-select");
              });
            } else {
              document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
                el.classList.add("input-empty");
              });
            }
          }
        });
      } else {
        if (e === "save") {
          saveUser();
        } else {
          setwizard(e);
        }
      }
    }, 20);
  };
  const [modalChangePassword, setmodalChangePassword] = useState();

  useEffect(() => {
    setbreadcrumb([{ label: "Gerenciar Usuários", url: "/admin/users" }, { label: user?.username || "Novo Usuário" }]);
  }, [user, setbreadcrumb]);

  return (
    <Main>
      {isUser && (
        <ModalChangePass
          show={modalChangePassword}
          user_id={userId}
          onHide={() => {
            setmodalChangePassword(false);
          }}
        />
      )}
      {!loadingPage ? (
        <Content>
          <Row>
            <Col>
              <div className="mb-3">
                <Wizard
                  selected={wizard}
                  options={[
                    { label: "Dados e Permissões", onClick: () => advanceStep(1) },
                    { label: "Recursos e Atendimentos", onClick: () => advanceStep(2) },
                  ]}
                />
              </div>
            </Col>
          </Row>
          {wizard === 1 && (
            <Row>
              <Col sm={6}>
                <Form.Group>
                  <span>Nome Completo</span>
                  <Form.Control
                    // disabled={isUser}
                    value={user.username || ""}
                    name="us3r.us3rnam3"
                    onChange={e => {
                      setuser({
                        ...user,
                        username: e.target.value,
                      });
                    }}
                    autoComplete="off"
                  />
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group>
                  <span>Email</span>
                  <Form.Control
                    // disabled={isUser}
                    value={user.email || ""}
                    name="us3r.3m4il"
                    onChange={e => {
                      setuser({
                        ...user,
                        email: e.target.value,
                      });
                    }}
                    autoComplete="off"
                  />
                </Form.Group>
              </Col>
              <Col sm={6} className="mt-2">
                <Form.Group>
                  <span>Celular</span>
                  <Phone
                    valueChange={e => {
                      setuser({
                        ...user,
                        cell: e,
                      });
                    }}
                    value={user.cell || ""}
                    name="user.cell"
                  />
                </Form.Group>
              </Col>
              <Col sm={6} className="mt-2">
                <Form.Group>
                  <span>CPF</span>
                  <InputDocument
                    valueChange={e => {
                      setuser({
                        ...user,
                        cpf: e,
                      });
                    }}
                    type="cpf"
                    // disabled={isUser}
                    value={user.cpf || ""}
                    name="user.cpf"
                  />
                </Form.Group>
              </Col>
              <Col sm={6} className="mt-2">
                <Form.Group>
                  <span>Setor</span>
                  <Slct
                    options={[
                      {
                        value: SYSTEM_ADMIN_SECTOR,
                        label: SYSTEM_ADMIN_SECTOR,
                        disabled: !isSystemAdmin,
                      },
                      { value: "Financeiro", label: "Financeiro" },
                      { value: "Marketing", label: "Marketing" },
                      { value: "Operacional", label: "Operacional" },
                      { value: "Diretoria", label: "Diretoria" },
                      { value: "Comercial", label: "Comercial" },
                      { value: "Designer", label: "Designer" },
                      { value: "Atendimento", label: "Atendimento" },
                    ]}
                    placeholder="..."
                    name="user.sector"
                    value={user.sector || ""}
                    onChange={e => {
                      setuser({
                        ...user,
                        sector: e.value,
                      });
                    }}
                    // isDisabled={isUser}
                  />
                </Form.Group>
              </Col>
              <Col sm={6} className="mt-2">
                <Form.Group>
                  <span>Gerência?</span>
                  <div className={styleTab.tab}>
                    <button
                      type="button"
                      onClick={() => {
                        setuser({
                          ...user,
                          is_admin: true,
                        });
                      }}
                      className={user.is_admin && "active"}
                    >
                      Sim
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setuser({
                          ...user,
                          is_admin: false,
                        });
                      }}
                      className={!user.is_admin && "active"}
                    >
                      Não
                    </button>
                  </div>
                </Form.Group>
              </Col>
              <Col sm={12} className="mt-2">
                <Form.Group>
                  <span>Permissões</span>
                  <Slct
                    options={templates || []}
                    placeholder="Carregar Modelo de Permissões..."
                    value={user?.permissions}
                    className="mb-2"
                    onChange={ev => {
                      setuser({
                        ...user,
                        permissions: ev.value,
                      });
                    }}
                  />
                  <Permissions
                    setpermissions={(group, action, value) => {
                      let _value = !!user?.permissions ? user?.permissions[group][action] : false;
                      setuser({
                        ...user,
                        permissions: {
                          ...user?.permissions,
                          [group]: {
                            ...user?.permissions[group],
                            [action]: value !== undefined ? value : !_value,
                          },
                        },
                      });
                    }}
                    setAll={(group, value) => {
                      const _group = user?.permissions[group];

                      Object.keys(_group).forEach(function (__action) {
                        _group[__action] = value;
                      });
                      setuser({
                        ...user,
                        permissions: {
                          ...user.permissions,
                          [group]: _group,
                        },
                      });
                    }}
                    permissions={[
                      {
                        label: "Formando",
                        group: "trainee",
                        options: [
                          { label: "Criação", value: user?.permissions?.trainee?.create, action: "create" },
                          { label: "Leitura", value: user?.permissions?.trainee?.reading, action: "reading" },
                          { label: "Edição", value: user?.permissions?.trainee?.update, action: "update" },
                          {
                            label: "Leitura do Financeiro",
                            value: user?.permissions?.trainee?.financialReading,
                            action: "financialReading",
                          },
                          {
                            label: "Alterar senha",
                            value: user?.permissions?.trainee?.updatePassword,
                            action: "updatePassword",
                          },
                          {
                            label: "Registrar Distrato",
                            value: user?.permissions?.trainee?.distrato,
                            action: "distrato",
                          },
                        ],
                      },
                      {
                        label: "Calendário",
                        group: "calendar",
                        options: [
                          {
                            label: "Criar para turma",
                            value: user?.permissions?.calendar?.createForClass,
                            action: "createForClass",
                          },
                          {
                            label: "Editar para turma",
                            value: user?.permissions?.calendar?.editForClass,
                            action: "editForClass",
                          },
                          { label: "Criar para usuário", value: user?.permissions?.calendar?.create, action: "create" },
                          {
                            label: "Editar para usuário",
                            value: user?.permissions?.calendar?.update,
                            action: "update",
                          },
                          {
                            label: "Recalcular Calendario",
                            value: user?.permissions?.calendar?.recalc,
                            action: "recalc",
                          },
                        ],
                      },
                      {
                        label: "Turma / Comercial",
                        group: "commercial",
                        options: [
                          { label: "Criação", value: user?.permissions?.commercial?.create, action: "create" },
                          { label: "Leitura", value: user?.permissions?.commercial?.reading, action: "reading" },
                          { label: "Edição", value: user?.permissions?.commercial?.update, action: "update" },
                          {
                            label: "Leitura Filtro",
                            value: user?.permissions?.commercial?.readingFunnel,
                            action: "readingFunnel",
                          },
                          {
                            label: "Criar Modelos",
                            value: user?.permissions?.commercial?.createModel,
                            action: "createModel",
                          },
                          {
                            label: "Atualizar Modelos",
                            value: user?.permissions?.commercial?.updateModel,
                            action: "updateModel",
                          },
                          {
                            label: "Criação de Turma Legado",
                            value: user?.permissions?.commercial?.createLegacy,
                            action: "createLegacy",
                          },
                          {
                            label: "Leitura de Arquivos",
                            value: user?.permissions?.commercial?.fileReading,
                            action: "fileReading",
                          },
                          {
                            label: "Upload de Arquivos",
                            value: user?.permissions?.commercial?.fileCreate,
                            action: "fileCreate",
                          },
                          {
                            label: "Deletar Arquivos",
                            value: user?.permissions?.commercial?.fileDelete,
                            action: "fileDelete",
                          },
                        ],
                      },
                      {
                        label: "Atendimento",
                        group: "attendance",
                        options: [
                          { label: "Criação", value: user?.permissions?.attendance?.create, action: "create" },
                          { label: "Leitura", value: user?.permissions?.attendance?.reading, action: "reading" },
                          {
                            label: "Enviar Mensagem",
                            value: user?.permissions?.attendance?.sendMessages,
                            action: "sendMessages",
                          },
                          {
                            label: "Atualizar Informações",
                            value: user?.permissions?.attendance?.updateInfos,
                            action: "updateInfos",
                          },
                          {
                            label: "Finalizar Atendimento",
                            value: user?.permissions?.attendance?.finishAttendance,
                            action: "finishAttendance",
                          },
                          {
                            label: "Leitura de Arquivos",
                            value: user?.permissions?.attendance?.fileReading,
                            action: "fileReading",
                          },
                          {
                            label: "Upload de Arquivos",
                            value: user?.permissions?.attendance?.fileCreate,
                            action: "fileCreate",
                          },
                        ],
                      },
                      {
                        label: "Recebimentos",
                        group: "financialGroup",
                        options: [
                          { label: "Leitura", value: user?.permissions?.financialGroup?.reading, action: "reading" },
                          {
                            label: "Criação/Renegociação",
                            value: user?.permissions?.financialGroup?.create,
                            action: "create",
                          },
                          {
                            label: "Edição de Data",
                            value: user?.permissions?.financialGroup?.update,
                            action: "update",
                          },
                          {
                            label: "Recebimento Manual",
                            value: user?.permissions?.financialGroup?.paymentDown,
                            action: "paymentDown",
                          },
                        ],
                      },
                      {
                        label: "Pagamentos",
                        group: "financialCompany",
                        options: [
                          { label: "Criação", value: user?.permissions?.financialCompany?.create, action: "create" },
                          { label: "Leitura", value: user?.permissions?.financialCompany?.reading, action: "reading" },
                          {
                            label: "Edição",
                            value: user?.permissions?.financialCompany?.update,
                            action: "update",
                          },
                          {
                            label: "Baixa de Pagamento",
                            value: user?.permissions?.financialCompany?.paymentDown,
                            action: "paymentDown",
                          },
                        ],
                      },
                      {
                        label: "Fornecedores",
                        group: "suppliers",
                        options: [
                          { label: "Criação", value: user?.permissions?.suppliers?.create, action: "create" },
                          { label: "Leitura", value: user?.permissions?.suppliers?.reading, action: "reading" },
                          { label: "Edição", value: user?.permissions?.suppliers?.update, action: "update" },
                        ],
                      },
                      {
                        label: "Instituições",
                        group: "institutions",
                        options: [
                          { label: "Criação", value: user?.permissions?.institutions?.create, action: "create" },
                          { label: "Leitura", value: user?.permissions?.institutions?.reading, action: "reading" },
                          { label: "Edição", value: user?.permissions?.institutions?.update, action: "update" },
                        ],
                      },
                      {
                        label: "Relatórios",
                        group: "reports",
                        options: [{ label: "Leitura", value: user?.permissions?.reports?.reading, action: "reading" }],
                      },
                    ]}
                  />
                </Form.Group>
              </Col>
              {!isUser && (
                <>
                  <Col sm={6}>
                    <span>Senha de Acesso</span>
                    <Form.Control style={{ position: "absolute", left: "-9999px" }} />
                    <Form.Control
                      type="password"
                      autocomplete="off"
                      value={user.password || ""}
                      name="us3r.p4ssw0rd"
                      onChange={e => {
                        setuser({
                          ...user,
                          password: e.target.value,
                        });
                        // stragenPasswordValidation(e.target.value);
                      }}
                    />
                  </Col>
                  <Col sm={6}>
                    <Form.Group className="lince-input">
                      <span>Confirmar Senha</span>
                      <div className="lince-input__text">
                        <Form.Control
                          type="password"
                          name="checkPassword"
                          value={user.password_confirm || ""}
                          onChange={e => {
                            setuser({
                              ...user,
                              password_confirm: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col sm={6} className="mt-3">
                    <PasswordStrength password={user.password || ""} />
                  </Col>
                </>
              )}
            </Row>
          )}
          {wizard === 2 && (
            <Row>
              <Col sm={12}>
                <h2 className="mini-title">Recursos</h2>
                <p className="small-label font-italic mb-0">
                  Recursos para classificar seus fornecedores e montar os orçamentos detalhados.
                </p>
              </Col>
              {categories &&
                categories.map(e => (
                  <Col sm={6} className="mt-2">
                    <Form.Group>
                      <span>{e.name}</span>
                      {(user.access || !isUser) && (
                        <Slct
                          className="w-100"
                          options={e.resource || []}
                          isMulti="true"
                          placeholder="..."
                          value={user?.resource?.filter(e2 => e.resource.some(e3 => e2.value === e3.value)) || []}
                          onChange={ev => {
                            let _resources = [...user?.resource];
                            _resources = _resources.concat(ev);
                            _resources = [...new Set(_resources)];
                            setuser({
                              ...user,
                              resource: _resources,
                            });
                          }}
                        />
                      )}
                    </Form.Group>
                  </Col>
                ))}
              <Col sm={12}>
                <h2 className="mini-title mt-4">Atendimento</h2>
                <p className="small-label font-italic mb-0">
                  Assuntos que possam ser motivos de abertura de tickets para atendimento que não estejam ligados aos
                  recursos listados na seção anterior.
                </p>
              </Col>
              {categoriesAtd &&
                categoriesAtd.map(e => (
                  <Col sm={6} className="mt-2">
                    <Form.Group>
                      <span>{e.name}</span>
                      {(user.access || !isUser) && (
                        <Slct
                          className="w-100"
                          options={e.resource || []}
                          isMulti="true"
                          placeholder="..."
                          value={user?.resource?.filter(e2 => e.resource.some(e3 => e2.value === e3.value)) || []}
                          onChange={ev => {
                            let _resources = [...user?.resource];
                            _resources = _resources.concat(ev);
                            _resources = [...new Set(_resources)];
                            setuser({
                              ...user,
                              resource: _resources,
                            });
                          }}
                        />
                      )}
                    </Form.Group>
                  </Col>
                ))}
            </Row>
          )}
          <Row className="mt-2">
            <Col className="justify-content-between d-flex">
              <div>
                {wizard > 1 && (
                  <button
                    className={`mr-2 ${styleButton.button_clean}`}
                    type="button"
                    onClick={() => advanceStep(wizard - 1)}
                  >
                    Voltar
                  </button>
                )}
                {isUser && (
                  <button
                    type="button"
                    className={styleButton.button_clean}
                    onClick={() => {
                      setmodalChangePassword(true);
                    }}
                  >
                    Alterar Senha
                  </button>
                )}
              </div>
              <div>
                {wizard === 1 && (
                  <button className={styleButton.button_ghost} type="button" onClick={() => advanceStep(wizard + 1)}>
                    Avançar
                  </button>
                )}
                {wizard === 2 && (
                  <button className={`${styleButton.button_primary}`} type="button" onClick={() => advanceStep("save")}>
                    Salvar
                  </button>
                )}
                {/* {(userId && window.location.pathname !== '/profile') && (
                  <button
                    onClick={() => deleteUser(userId)}
                    type="button"
                    className={`ml-2 ${styleButton.button_ghost_error}`} >
                    Apagar
                  </button>
                )} */}
              </div>
            </Col>
          </Row>
        </Content>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
